import {createContext} from "react";
import { IConsultaiAppContext } from "./interfaces/IConsultaiAppContext";



const ConsultaiAppContext = createContext<IConsultaiAppContext|undefined>(undefined);
export default ConsultaiAppContext;

